export const FETCH_DEVICE_DETAILS_INIT = 'FETCH_DEVICE_DETAILS_INIT';
export const FETCH_DEVICE_DETAILS_DONE = 'FETCH_DEVICE_DETAILS_DONE';
export const FETCH_DEVICE_DETAILS_FAIL = 'FETCH_DEVICE_DETAILS_FAIL';

export const UPDATE_LICENSE = 'UPDATE_LICENSE';
